import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { omit } from "lodash";

import { FranchiseDetails, MyBusinessCardProps } from "./types";
import DataTable from "./components/DataTable";
import MyBusinessCardSkeleton from "./components/Skeleton";

const useStyles = makeStyles(theme => ({
  cardContent: {
    padding: 0,
  },
  item: {
    padding: theme.spacing(0),

    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3, 5, 3, 2),
    },
  },
}));

const MyBusinessCard: React.FC<MyBusinessCardProps> = ({
  loading = false,
  franchiseDetails,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return loading ? (
    <MyBusinessCardSkeleton />
  ) : (
    <Card data-test="my-business-card">
      <CardHeader title="My Business" />
      <Divider />
      <CardContent className={classes.cardContent}>
        <Grid
          container
          direction={isMobile ? "column" : "row"}
          wrap="wrap"
          justify="space-between"
        >
          {franchiseDetails?.map((franchise: FranchiseDetails) => (
            <Grid
              key={franchise.id}
              item
              sm={6}
              xs={12}
              className={classes.item}
            >
              <DataTable
                data={omit(franchise, "id")}
                title="My franchise details"
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MyBusinessCard;
